var libraryName = 'Feature Flag SDK';
var responseErrorMessages = {
  NOT_AUTHORIZED: 'You are not authorized or session has been expired. Please try again.',
  NO_DATA_AVAILABLE: 'No data available.',
  DEFAULT_ERROR_MESSAGE: 'There seems to be a problem, please retry after sometime.',
  ACCESS_DENIED: 'Access Denied/Forbidden.',
  FAILED_TO_FETCH_DATA: 'Failed to fetch the data',
  METHOD_NOT_ALLOWED: ''
};
var httpConstants = {
  SUCCESS: 'success',
  HTTP_METHODS: {
    GET: 'GET',
    POST: 'POST'
  },
  HTTP_REQ_ERROR_MAP: {
    401: {
      statusCode: 401,
      errorMessage: responseErrorMessages.NOT_AUTHORIZED
    },
    403: {
      statusCode: 403,
      errorMessage: responseErrorMessages.ACCESS_DENIED
    },
    404: {
      statusCode: 404,
      errorMessage: responseErrorMessages.NO_DATA_AVAILABLE
    },
    405: {
      statusCode: 405,
      errorMessage: responseErrorMessages.METHOD_NOT_ALLOWED
    }
  },
  HTTP_REQ_DEFAULT_HEADERS: {
    crossDomain: true,
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept',
    'Cache-Control': 'no-cache, no-store, must-revalidate'
  },
  CONTENT_TYPE: {
    appJson: 'application/json'
  }
};
var logLevels = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR'
};

export { httpConstants, libraryName, logLevels, responseErrorMessages };
